import styled from 'styled-components';
import { screenSizes} from 'app/components/mediaObject'

export const InventoryContainer = styled.div`
    margin:2rem auto;
    display:flex;
    justify-content:center;
    flex-wrap: wrap;
    max-width:${screenSizes.widescreen}px;
`